import { ACT_DVY_CHANGE } from "../actions/ActionTypes";

const initialState = {
	deliveryBoyList:[]
};

export default function(state = initialState, action) {
	if (action.type === ACT_DVY_CHANGE) {
		return Object.assign({}, state, action.props);
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/DeliveryBoyReducer.js